// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o4-1";
export var stateContainer = "_o4-0";